import { render, staticRenderFns } from "./_ChangePassword.vue?vue&type=template&id=1e7989d8"
import script from "./_ChangePassword.vue?vue&type=script&lang=js"
export * from "./_ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports